<template><Teleport to="body"><div v-if="auth.profile" class="identity-watermark" aria-hidden="true" :style="{ backgroundImage: `url('${background}')` }" /></Teleport></template>
<script setup lang="ts">
import { computed, onBeforeUnmount, ref } from "vue";
import { useRoute } from "vue-router";
import { useAuthStore } from "@/stores/auth";
const auth = useAuthStore(), route = useRoute(), now = ref(new Date());
const timer = setInterval(() => { now.value = new Date(); }, 60_000);
onBeforeUnmount(() => clearInterval(timer));
const escape = (value: string) => value.replace(/[&<>"']/g, char => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&apos;" })[char]!);
const background = computed(() => {
  const profile = auth.profile;
  if (!profile) return "";
  const identity = escape(`${profile.displayName} · ${profile.username}`);
  const date = now.value.toLocaleDateString("sv-SE", { timeZone: "Asia/Singapore" });
  const opacity = /^\/(contracts|customers|crm)(\/|$)/.test(route.path) ? 0.14 : 0.07;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="320" height="200"><g transform="translate(25 115) rotate(-22)" fill="#3e526b" fill-opacity="${opacity}" font-family="sans-serif" font-size="13"><text>${identity}</text><text y="22">${date}</text></g></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
});
</script>
<style scoped>
.identity-watermark { position: fixed; inset: 0; z-index: 2147483646; pointer-events: none; background-repeat: repeat; }
</style>
